export interface MusicGenre {
	id: string
	name: string
	url: string
}

export interface MusicGenreOption {
	value: string
	label: string
}

export interface MusicGenreGroup {
	label: string
	collapsed: boolean
	genres: MusicGenreOption[]
}

// TODO: Temporary fix - using local files due to CORS issues with media.brandtrack.fm
// Once CORS is fixed on the backend, revert to: 'https://media.brandtrack.fm/ai-tracks'
const AI_TRACKS_BASE_URL = '/ai-tracks'

// Helper to build track URL with proper encoding for spaces
const buildTrackUrl = (filename: string): string => {
	return `${AI_TRACKS_BASE_URL}/${encodeURIComponent(filename)}`
}

export const MUSIC_GENRES: { [key: string]: string } = {
	// Elegant
	asian: buildTrackUrl('Asian.mp3'),
	'bossa-nova': buildTrackUrl('Bossa Nova.mp3'),
	lounge: buildTrackUrl('Lounge.mp3'),
	orchestral: buildTrackUrl('Orchestral.mp3'),
	'swing-serenade': buildTrackUrl('Swing Serenade.mp3'),

	// Uplifting
	'easy-listening-2': buildTrackUrl('Easy Listening 2.mp3'),
	'easy-listening': buildTrackUrl('Easy listening.mp3'),
	'house-pop': buildTrackUrl('House Pop.mp3'),
	'orchestral-big': buildTrackUrl('Orchestral Big.mp3'),
	'orchestral-light': buildTrackUrl('Orchestral Light.mp3'),
	pop: buildTrackUrl('Pop.mp3'),

	// Stylish
	'acoustic-blues': buildTrackUrl('Acoustic Blues.mp3'),
	'funky-future-vibes': buildTrackUrl('Funky Future Vibes.mp3'),
	'funky-garage': buildTrackUrl('Funky Garage.mp3'),
	'funky-strut-jam': buildTrackUrl('Funky Strut Jam.mp3'),
	rock: buildTrackUrl('Rock.mp3'),
	'smooth-ride': buildTrackUrl('Smooth Ride.mp3'),

	// Modern
	ambient: buildTrackUrl('Ambient.mp3'),
	'cool-modern': buildTrackUrl('Cool & Modern.mp3'),
	'corporate-groove': buildTrackUrl('Corporate groove.mp3'),
	'corporate-motivation': buildTrackUrl('Corporate Motivation.mp3'),
}

export const DEFAULT_MUSIC_GENRE = 'pop'

export const MUSIC_GENRE_GROUPS: MusicGenreGroup[] = [
	{
		label: 'Elegant',
		collapsed: false,
		genres: [
			{ value: 'asian', label: 'Asian' },
			{ value: 'bossa-nova', label: 'Bossa Nova' },
			{ value: 'lounge', label: 'Lounge' },
			{ value: 'orchestral', label: 'Orchestral' },
			{ value: 'swing-serenade', label: 'Swing Serenade' },
		],
	},
	{
		label: 'Uplifting',
		collapsed: false,
		genres: [
			{ value: 'easy-listening', label: 'Easy Listening' },
			{ value: 'easy-listening-2', label: 'Easy Listening 2' },
			{ value: 'house-pop', label: 'House Pop' },
			{ value: 'orchestral-big', label: 'Orchestral Big' },
			{ value: 'orchestral-light', label: 'Orchestral Light' },
			{ value: 'pop', label: 'Pop' },
		],
	},
	{
		label: 'Stylish',
		collapsed: false,
		genres: [
			{ value: 'acoustic-blues', label: 'Acoustic Blues' },
			{ value: 'funky-future-vibes', label: 'Funky Future Vibes' },
			{ value: 'funky-garage', label: 'Funky Garage' },
			{ value: 'funky-strut-jam', label: 'Funky Strut Jam' },
			{ value: 'rock', label: 'Rock' },
			{ value: 'smooth-ride', label: 'Smooth Ride' },
		],
	},
	{
		label: 'Modern',
		collapsed: false,
		genres: [
			{ value: 'ambient', label: 'Ambient' },
			{ value: 'cool-modern', label: 'Cool & Modern' },
			{ value: 'corporate-groove', label: 'Corporate Groove' },
			{ value: 'corporate-motivation', label: 'Corporate Motivation' },
		],
	},
]

// Helper to get all genres as flat array
export const getAllMusicGenres = (): MusicGenreOption[] => {
	return MUSIC_GENRE_GROUPS.flatMap((group) => group.genres)
}

// Helper to get genre URL
export const getMusicGenreUrl = (genreValue: string): string | undefined => {
	return MUSIC_GENRES[genreValue]
}
